/**
 * Check if the cart response only has one item which is the membership
 * If so, remove it from the cart
 * @param {object} response - The cloned response object from fetch
 */
let updateRequest = null;

const membershipHandles = [
  'sassy-community-membership', 'gold-community-membership', 'diamond-community-membership',
  'sassy-community-member', 'gold-community-member', 'diamond-community-member',
]

async function requestMembershipCheck() {
  let hasMembership = false;
  
  await fetch('/cart.js?debug=1', { 
    method: 'GET',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With':'xmlhttprequest',
    }
  })
    .then(response => response.json())
    .then(response => {
      response.items.forEach(item => {
        if (membershipHandles.includes(item.handle)) {
          hasMembership = true;
          return hasMembership;
        }
      });
    });

  return hasMembership;
}

function removeDuplicateMemberships(response) {
  response.json().then((data) => {
    try {
      let mainMembershipItem = null;
      let removedKeyIds = [];
      
      data.items.forEach(item => {
        if (membershipHandles.includes(item.handle)) {
          if (mainMembershipItem == null) {
            mainMembershipItem = item;
          } else {
            removedKeyIds.push(item.key);
          }
        }
      })

      if (mainMembershipItem) {
        updateMembershipLineItems(mainMembershipItem, removedKeyIds);
      }
    } catch (e) {
      console.error("error - checkForMembershipOnlyItems():", e);
    }
  });
}

/**
 * Helper function to remove line item using shopify /cart/change.js
 * @param {string} line_item_key - The line item key that will be removed
 */
async function updateMembershipLineItems(mainMembershipItem, removedKeyIds = []) {
  // Request is already on the way, ignore this
  if (updateRequest !== null) {
    return;
  }

  // Define the data for the POST request
  let payload = {
    updates: {},
  };

  // Ensure the main membership only has 1 quantity
  if (mainMembershipItem && mainMembershipItem.quantity > 1) {
    payload.updates[mainMembershipItem.key] = 1;
  }

  // Delete the rest
  removedKeyIds.forEach(id => {
    payload.updates[id] = 0;
  })

  if (Object.values(payload.updates).length <= 0) {
    return;
  }
  
  // Define the options for the fetch request
  const options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify(payload),
  };

  // Make the fetch request
  updateRequest = true;
  await fetch('/cart/update.js', options)
    .then((response) => {
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      return response.json();
    })
    .then((data) => {
      // Handle the response data (if needed)
      console.log("Item removed successfully:", data);
    })
    .catch((error) => {
      // Handle errors
      console.error("Error:", error);
    })
    .finally(() => {
      updateRequest = null;
    });
}

// Intercept the fetch method
var originalFetch = window.fetch;
window.fetch = function () {
  var url = arguments[0];

  if (url === "/cart.js") {
    return originalFetch.apply(this, arguments).then((response) => {
      const responseClone = response.clone();
      removeDuplicateMemberships(responseClone);

      return response;
    });
  }

  return originalFetch.apply(this, arguments);
};

if (typeof(window.membership) === 'undefined') {
  window.membership = {
    removeDuplicateMemberships: removeDuplicateMemberships,
    updateMembershipLineItems: updateMembershipLineItems,
    requestMembershipCheck: requestMembershipCheck,
  };
}
